import {axios as http} from "@/plugins/http"

export default class Api {
    static statisticPostOrders(id, typeId) {
        return http.post("/api/v1/statistic/post-orders", {
            post_id: id,
            type_id: typeId,
        }).then((resp) => {
            return resp.data["items"]
        })
    }

    static statisticPostOrdersChain(id, typeId) {
        return http.post("/api/v1/statistic/post-orders-chain", {
            post_id: id,
            type_id: typeId,
        }).then((resp) => {
            return resp.data["items"]
        })
    }
}
